"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNotErrorRecordish = exports.assertNotErrorRecord = exports.assertNotErrorRecordResponse = exports.isErrorRecordResponse = exports.isErrorRecord = exports.jsErrorToRecord = void 0;
const plus_plus_plus_1 = require("./plus-plus-plus");
function jsErrorToRecord(err, ...plusPlusPlusArgs) {
    const error = new plus_plus_plus_1.PlusPlusPlus(err, ...plusPlusPlusArgs);
    return error.dataWithInternalInfo();
}
exports.jsErrorToRecord = jsErrorToRecord;
function isErrorRecord(obj) {
    return !!(obj && typeof obj === 'object' && obj.errorCode);
}
exports.isErrorRecord = isErrorRecord;
function isErrorRecordResponse(obj) {
    return !!obj && typeof obj === 'object' && obj.error && isErrorRecord(obj.error);
}
exports.isErrorRecordResponse = isErrorRecordResponse;
function assertNotErrorRecordResponse(obj, ...extraErrorItems) {
    if (isErrorRecordResponse(obj)) {
        throw new plus_plus_plus_1.PlusPlusPlus(obj.error, ...extraErrorItems);
    }
}
exports.assertNotErrorRecordResponse = assertNotErrorRecordResponse;
function assertNotErrorRecord(obj, ...extraErrorItems) {
    if (isErrorRecord(obj)) {
        throw new plus_plus_plus_1.PlusPlusPlus(obj, ...extraErrorItems);
    }
}
exports.assertNotErrorRecord = assertNotErrorRecord;
function assertNotErrorRecordish(obj, ...extraErrorItems) {
    assertNotErrorRecordResponse(obj);
    assertNotErrorRecord(obj);
}
exports.assertNotErrorRecordish = assertNotErrorRecordish;
//# sourceMappingURL=error-record-util.js.map